export default "__VITE_ASSET__BfUPbTMz__"